import { useState } from 'react';
import { useSelector } from 'react-redux';

import Button from 'components/field/Button';
import Icon from 'components/global/Icon';
import Image from 'components/global/Image';
import Menu from 'components/global/Menu';
import Typography from 'components/global/Typography';

import useChangeLanguage from 'hooks/useChangeLanguage';

import { languages } from 'utils/localization';

import { faAngleDown } from '@fortawesome/pro-solid-svg-icons';

import LinkExpired from './LinkExpired';
import SmsFooter from './SmsFooter';
import * as S from './styled/SmsLayout.styled';

const SmsLinkExpired = () => {
	const changeLanguage = useChangeLanguage();
	const localization = useSelector((state) => state.layout.localization);
	const [languageMenuButtonRef, setLanguageMenuButtonRef] = useState(null);

	return (
		<S.Container>
			<S.NavBar>
				<S.NavBarContent>
					<Image
						url="https://storage.googleapis.com/tryoto-public/public/assets/images/otoLogo.png"
						width={'4.5rem'}
						height={'4.5rem'}
					/>
					<Button variant="borderless" ref={setLanguageMenuButtonRef}>
						<Image url={localization.icon} width="20px" height="15px" />
						<Typography>{localization.name}</Typography>
						<Icon icon={faAngleDown} />
					</Button>
					<Menu
						buttonRef={languageMenuButtonRef}
						menuItems={languages.map((language) => ({
							label: language.name,
							img: language.icon,
							imgProps: { width: '20px', height: '15px' },
							selected: language.code === localization.code,
							action: () => changeLanguage(language.code)
						}))}
					/>
				</S.NavBarContent>
			</S.NavBar>

			<S.ScrollContainer>
				<S.Content>
					<S.ContentWrapper>
						<LinkExpired />
					</S.ContentWrapper>
				</S.Content>

				<SmsFooter />
			</S.ScrollContainer>
		</S.Container>
	);
};

export default SmsLinkExpired;
